import axios from 'axios';
import API_CONFIG from '../config/api.config';
import { getAuthHeader } from './authService';

const BASE = `${API_CONFIG.BASE_URL}/ai-assistant`;

export const getAiAssistantStatus = async () => {
  const response = await axios.get(`${BASE}/status`, { headers: getAuthHeader() });
  return response.data;
};

export const bootstrapAiAssistant = async () => {
  const response = await axios.post(`${BASE}/bootstrap`, {}, { headers: getAuthHeader() });
  return response.data;
};

export const resetAiAssistantChat = async () => {
  const response = await axios.post(`${BASE}/reset`, {}, { headers: getAuthHeader() });
  return response.data;
};

export const sendAiAssistantMessage = async ({ message, sessionId, dashboardSnapshot }) => {
  const response = await axios.post(
    `${BASE}/message`,
    { message, sessionId, dashboardSnapshot },
    { headers: getAuthHeader(), timeout: 90000 }
  );
  return response.data;
};

export const isPlanFeatureEnabled = (planFeatures, key) => {
  if (!planFeatures || typeof planFeatures !== 'object') return false;
  const value = planFeatures[key];
  return value === true || (typeof value === 'string' && value.toLowerCase() === 'true');
};

const aiAssistantService = {
  getAiAssistantStatus,
  bootstrapAiAssistant,
  resetAiAssistantChat,
  sendAiAssistantMessage,
  isPlanFeatureEnabled,
};

export default aiAssistantService;
